import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "@/data/products";
import { waLink } from "@/lib/whatsapp";
import { trackWhatsAppClick } from "@/lib/analytics";

// Barra fixa inferior — visível apenas em mobile. Reduz fricção: 1 toque para ligar ou WhatsApp.
export const MobileStickyBar = () => {
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-[#E5E3DB] grid grid-cols-2 gap-2 p-2.5 shadow-[0_-10px_30px_-10px_rgba(0,0,0,0.15)]">
      <a
        href={`tel:+${BRAND.phoneE164}`}
        data-testid="sticky-call-btn"
        onClick={() => { window.dataLayer=window.dataLayer||[]; window.dataLayer.push({event:'phone_click', event_label:'sticky_bar'}); }}
        className="inline-flex items-center justify-center gap-2 bg-[#2D4A3E] hover:bg-[#1F352B] text-white font-medium py-3 rounded-full text-sm"
      >
        <Phone className="h-4 w-4" strokeWidth={2} />
        Ligar agora
      </a>
      <a
        href={waLink("Olá, gostaria de fazer um pedido de coroa de flores.")}
        target="_blank" rel="noreferrer"
        data-testid="sticky-whatsapp-btn"
        onClick={() => trackWhatsAppClick("mobile_sticky")}
        className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1FB855] text-white font-medium py-3 rounded-full text-sm"
      >
        <MessageCircle className="h-4 w-4" strokeWidth={2} />
        WhatsApp
      </a>
    </div>
  );
};
